<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Informe general</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col cols="6" md="4">
                    <date-select
                        prepend-icon="mdi-account-search"
                        v-model="fecha_inicio"
                        label="Desde"
                    ></date-select>
                </v-col>
                <v-col cols="6">
                    <date-select
                        prepend-icon="mdi-account-search"
                        v-model="fecha_fin"
                        label="Hasta"
                    ></date-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" md="4">
                    <clienteSelect v-model="cliente" label="Cliente">
                    </clienteSelect>
                </v-col>
            </v-row>
        </v-card-text>
        <v-data-table
            dense
            :headers="headers"
            :items="Ordenes"
            :items-per-page="15"
            item-key="id"
            class="elevation-1 mt-4"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            :server-items-length="total_orden_trabajo"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.presupuesto.fecha="{ item }">
                <span>{{
                    item.presupuesto
                        ? new Date(item.presupuesto.fecha).toLocaleDateString(
                              "en-GB"
                          )
                        : ""
                }}</span>
            </template>

            <template v-slot:item.presupuesto.fecha_aceptacion="{ item }">
                <span>{{
                    item.presupuesto && item.presupuesto.fecha_aceptacion
                        ? new Date(
                              item.presupuesto.fecha_aceptacion
                          ).toLocaleDateString("en-GB")
                        : ""
                }}</span>
            </template>

            <template v-slot:item.presupuesto.fecha_ejecucion="{ item }">
                <span>{{
                    item.presupuesto && item.presupuesto.fecha_ejecucion
                        ? new Date(
                              item.presupuesto.fecha_ejecucion
                          ).toLocaleDateString("en-GB")
                        : ""
                }}</span>
            </template>

            <template v-slot:item.created_at="{ item }">
                <span>{{
                    new Date(item.created_at).toLocaleDateString("en-GB")
                }}</span>
            </template>

            <template v-slot:item.planificacion_fechas.max_fecha="{ item }">
                <span>{{
                    item.planificacion_fechas
                        ? new Date(
                              item.planificacion_fechas.max_fecha
                          ).toLocaleDateString("en-GB")
                        : ""
                }}</span>
            </template>

            <template v-slot:item.planificacion_fechas.max_fecha_fin="{ item }">
                <span>{{
                    item.planificacion_fechas
                        ? new Date(
                              item.planificacion_fechas.max_fecha_fin
                          ).toLocaleDateString("en-GB")
                        : ""
                }}</span>
            </template>
        </v-data-table>
    </v-card>
</template>
<style>
.round {
    border-radius: 10000px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.Back-Yellow {
    background-color: rgb(255, 243, 132);
}
.Back-Green {
    background-color: rgba(158, 255, 158, 0.582);
}
.Back-Orange {
    background-color: rgb(248, 182, 60);
}
.Back-Blue {
    background-color: rgb(93, 173, 248);
}
.Back-Brown {
    background-color: rgba(80, 56, 56, 0.411);
}
</style>
<script>
import clienteSelect from "../../../components/general/clienteSelect.vue";

export default {
    components: {
        clienteSelect,
    },
    data() {
        return {
            total_orden_trabajo: 0,
            page: 1,
            cantidad: 15,
            headers: [
                {
                    text: "Cliente",
                    value: "cliente.nombre_comercial",
                    sortable: false,
                },
                {
                    text: "Alta petición",
                    value: "presupuesto.fecha",
                    sortable: false,
                },

                {
                    text: "Creación de presupuesto",
                    value: "presupuesto.fecha",
                    sortable: false,
                },
                {
                    text: "Aceptación de presupuesto",
                    value: "presupuesto.fecha_aceptacion",
                    sortable: false,
                },
                {
                    text: "Ejecución de presupuesto",
                    value: "presupuesto.fecha_ejecucion",
                    sortable: false,
                },
                {
                    text: "Creación de la obra",
                    value: "created_at",
                    sortable: false,
                },
                {
                    text: "Inicio de planificación de la obra",
                    value: "planificacion_fechas.max_fecha",
                    sortable: false,
                },
                {
                    text: "Finalización de la obra",
                    value: "planificacion_fechas.max_fecha_fin",
                    sortable: false,
                },
            ],
            Ordenes: [],
            fecha_inicio: "",
            fecha_fin: "",
            cliente: null,
            search: "",
            loading: false,
        };
    },
    created() {
        let date = new Date();
        this.fecha_inicio = new Date(date.getFullYear(), date.getMonth(), 1)
            .toISOString()
            .split("T")[0];
        this.fecha_fin = new Date(date.getFullYear(), date.getMonth() + 1, 0)
            .toISOString()
            .split("T")[0];

        this.getOrdenes();
        // this.getTiposOrden();
    },
    methods: {
        ChangeSize(event) {
            this.cantidad = event;
            this.getOrdenes();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getOrdenes();
        },
        getOrdenes() {
            this.loading = true;
            // let filtros = this.filterString;
            let amount =
                this.cantidad == -1 ? this.total_orden_trabajo : this.cantidad;
            axios
                .get(
                    `api/informe-general?page=${this.page}&amount=${amount}${this.filtros}`
                )
                .then(
                    (res) => {
                        // this.Ordenes = res.data;
                        this.Ordenes = res.data.data;
                        this.total_orden_trabajo = res.data.total;
                        //this.filter_headers[0].items = res.data.data;

                        console.log("Ordenes", this.Ordenes);
                    },
                    (err) => {
                        this.$custom_error("Error consultando las obras");
                    }
                );
        },
    },
    computed: {
        rol: function () {
            let rol = localStorage.getItem("role");
            console.log(rol);
            return rol;
        },
        isloading: function () {
            // return this.$store.getters.getloading
        },
        filtros() {
            return `&fecha_inicio=${this.fecha_inicio}&fecha_fin=${this.fecha_fin}&cliente=${this.cliente}`;
        },

        // filterString() {
        //     let filtros = "";

        //     if (
        //         this.filtros_prueba.search != null &&
        //         this.filtros_prueba.search != ""
        //     ) {
        //         filtros += `&busqueda=${this.filtros_prueba.search}`;
        //     }

        //     this.filter_headers.forEach((head) => {
        //         if (this.filtros_prueba[head.model]) {
        //             if (
        //                 (this.filtros_prueba[head.model].value != "" &&
        //                     this.filtros_prueba[head.model].value != null) ||
        //                 (this.filtros_prueba[head.model].nombre != "" &&
        //                     this.filtros_prueba[head.model].nombre != null)
        //             ) {
        //                 filtros += `&${head.model}=${
        //                     this.filtros_prueba[head.model].value
        //                 }`;
        //             }
        //         }
        //     });
        //     if (this.id_presupuesto) {
        //         filtros += `&id_presupuesto=${this.id_presupuesto}`;
        //     }
        //     return filtros;
        // },
    },
    watch: {
        fecha_inicio: {
            deep: true,
            handler: function (val) {
                this.getOrdenes();
            },
        },
        fecha_fin: {
            deep: true,
            handler: function (val) {
                this.getOrdenes();
            },
        },
        cliente: {
            handler: function (val) {
                this.getOrdenes();
            },
        },
    },
};
</script>
